import React, { useEffect, useState } from 'react';
import { Select, Progress } from 'antd';
import './style.scss';
import { ModalWrap } from '../../component/modal-wrap';
import { IAPIGameItem } from '../../../model/api-modules';
import { fetchGameList } from '../../../api';
import { formatStudioList } from '../../game-content/lib';
import { fetchEnvCollectionList } from '../../../api/game/env';
import getFormatMessage from '../../../locales/get-format-message';
import stepFinish from '../../../../src/assets/svg/step-finish.svg';
import downloadingIcon from '../../../../src/assets/images/downloading-icon.png';
import { IDownloadCenterObject } from '../../../model/api-modules/download-center';

interface IProps {
  readonly onClose: () => void;
  readonly selectStudio: string | undefined;
  readonly setSelectStudio: (value: string | undefined) => void;
  readonly selectGame: string | undefined;
  readonly setSelectGame: (value: string | undefined) => void;
  readonly selectEnv: string | undefined;
  readonly setSelectEnv: (value: string | undefined) => void;
  readonly downloadLoading: boolean;
  readonly onDownloadOk: () => Promise<boolean>;
  readonly onSecondaryConfirmation: () => Promise<boolean>;
  readonly showProgressBar: boolean;
  readonly progressBarNumber: number;
  readonly showConfirmModal: boolean;
  readonly setShowConfirmModal: (value: boolean) => void;
  readonly confirmLoading: boolean;
  readonly selectSdk: number[];
  readonly objectList: IDownloadCenterObject[];
  readonly downloadTips: string;
}

interface IOption {
  readonly label: string;
  readonly value: string;
}

export const DownloadModal = (props: IProps) => {
  // const [studioList, setStudioList] = useState<IAPIGameItem[]>([]);
  const [gameList, setGameList] = useState<IAPIGameItem[]>([]);
  const [gameOptions, setGameOptions] = useState<IOption[]>([]);
  const [envOptions, setEnvOptions] = useState<IOption[]>([]);
  const [studioOptions, setStudioOptions] = useState<IOption[]>([]);
  const urlParams = new URLSearchParams(window.location.search);
  const studioId = urlParams.get('studioId');
  // const studioOptions: IOption[] = [];

  useEffect(() => {
    initialization();
  }, []);

  const initialization = async () => {
    const res = await fetchGameList();
    if (res) {
      setGameList(res);
      const studioData = formatStudioList(res);
      // setStudioList(studioData);

      const studioOption: IOption[] = [];
      studioData.length !== 0 &&
        studioData.forEach((item) => {
          if (item.studioID) {
            studioOption.push({
              label: item.studioName,
              value: item.studioID,
            });
          }
        });
      setStudioOptions(studioOption);
      if (studioId) {
        const itemOption = studioOption.find((item) => item.value === studioId);
        if (itemOption) {
          changeStudio(studioId, res);
        }
      }
    }
  };

  const changeStudio = async (value: string, gameListData?: IAPIGameItem[]) => {
    props.setSelectStudio(value);
    props.setSelectGame(undefined);
    if (gameList || gameListData) {
      const currentGameList = gameListData || gameList;
      const newGameOptions: IOption[] = [];
      currentGameList.forEach((item) => {
        if (item.studioID === value && item.gameID) {
          newGameOptions.push({
            label: item.gameName,
            value: item.gameID,
          });
        }
      });
      setGameOptions(newGameOptions);
    }
  };
  const changeGame = async (value: string) => {
    props.setSelectGame(value);
    props.setSelectEnv(undefined);
    if (props.selectStudio) {
      const res = await fetchEnvCollectionList(props.selectStudio);
      if (res) {
        const newEnvOptions: IOption[] = [];
        res.forEach((item) => {
          if (item.gameID === value && item.envIncrementID) {
            newEnvOptions.push({
              label: item.envName,
              value: item.envIncrementID.toString(),
            });
          }
        });
        setEnvOptions(newEnvOptions);
      }
    }
  };

  const renderNoStepContent = () => {
    return (
      <div className="download-modal-box">
        <div className="download-tips">
          <span>{getFormatMessage(props.downloadTips)}</span>
          {props.progressBarNumber !== 100 && (
            <img src={downloadingIcon} className="download-tips-icon" />
          )}
        </div>
        <Progress percent={props.progressBarNumber} />
      </div>
    );
  };
  const renderContent = () => {
    return (
      <div className="download-modal-box">
        <div className="download-modal-step-box">
          <div className="download-modal-step">
            {props.showProgressBar ? (
              <img src={stepFinish} className="step-icon-finish" />
            ) : (
              <div className="step-icon-active">1</div>
            )}
            <div className="step-box">
              <div className="step-tips">
                {getFormatMessage('dowload_step_one')}
              </div>
              <div className="step-title">
                {getFormatMessage('link_to_the_title')}
              </div>
            </div>
          </div>
          <div className="download-modal-step-line"></div>
          <div className="download-modal-step">
            <div
              className={
                props.showProgressBar ? 'step-icon-active' : 'step-icon-wait'
              }
            >
              2
            </div>
            <div className="step-box">
              <div className="step-tips">
                {getFormatMessage('dowload_step_two')}
              </div>
              <div className="step-title">
                {getFormatMessage('packaging_integration')}
              </div>
            </div>
          </div>
        </div>
        {props.showProgressBar ? (
          <div>
            <div className="download-tips">
              <span>{getFormatMessage(props.downloadTips)}</span>
              {props.progressBarNumber !== 100 && (
                <img src={downloadingIcon} className="download-tips-icon" />
              )}
            </div>
            <Progress percent={props.progressBarNumber} />
          </div>
        ) : (
          <div>
            <div className="download-list-tips">
              {getFormatMessage('download_list_tips')}
            </div>
            <div style={{ marginTop: '24px' }}>
              <div>
                <span
                  style={{
                    display: 'inline-block',
                    width: '180px',
                    color: '#4E5969',
                    fontSize: '14px',
                    marginRight: '32px',
                  }}
                >
                  {getFormatMessage('download_studio')}
                </span>
                <span
                  style={{
                    display: 'inline-block',
                    width: '180px',
                    color: '#4E5969',
                    fontSize: '14px',
                    marginRight: '32px',
                  }}
                >
                  {getFormatMessage('title')}
                </span>
                {props.selectGame && (
                  <span style={{ color: '#4E5969', fontSize: '14px' }}>
                    {getFormatMessage('env')}
                  </span>
                )}
              </div>
              <div style={{ display: 'flex' }}>
                <Select
                  style={{ width: '180px', marginRight: '32px' }}
                  onChange={(value) => changeStudio(value)}
                  options={studioOptions}
                  value={props.selectStudio}
                  placeholder={getFormatMessage('please_select_studio')}
                  getPopupContainer={(node) => {
                    return node.parentNode || document.body;
                  }}
                  virtual={false}
                />
                <Select
                  style={{ width: '180px', marginRight: '32px' }}
                  onChange={(value) => changeGame(value)}
                  options={gameOptions}
                  value={props.selectGame}
                  placeholder={getFormatMessage('please_select_game')}
                  getPopupContainer={(node) => {
                    return node.parentNode || document.body;
                  }}
                  virtual={false}
                />
                {props.selectGame && (
                  <Select
                    style={{ width: '180px' }}
                    onChange={(value) => props.setSelectEnv(value)}
                    options={envOptions}
                    value={props.selectEnv}
                    placeholder={getFormatMessage('please_select_env')}
                    getPopupContainer={(node) => {
                      return node.parentNode || document.body;
                    }}
                    virtual={false}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderConfirmModal = () => {
    if (props.showConfirmModal) {
      return (
        <ModalWrap
          width="434px"
          cancelText={getFormatMessage('cancel_download_btn_continue')}
          oKText={getFormatMessage('confirm')}
          maskClosable={false}
          title={getFormatMessage('cancel_download')}
          onClose={() => props.setShowConfirmModal(false)}
          loading={props.confirmLoading}
          onOk={props.onSecondaryConfirmation}
        >
          <div>
            {getFormatMessage('cancel_download_time_remaining_tips', {
              params: {
                // 目前没有返回剩余时间
                timeRemaining: '5',
              },
            })}
          </div>
        </ModalWrap>
      );
    }
    return null;
  };

  let cancelText = '';
  if (props.showProgressBar) {
    if (props.progressBarNumber !== 100) {
      cancelText = getFormatMessage('cancel_download');
    } else {
      cancelText = getFormatMessage('close');
    }
  }

  const needConfirmObjects = props.objectList.filter((item) =>
    ['InGame GaaS SDK', 'InGame SDK', 'InGame Tool'].includes(item.Name)
  );
  const needConfirmObjectIds = needConfirmObjects.map((item) => item?.id);

  if (needConfirmObjectIds.some((id) => props.selectSdk.includes(id))) {
    return (
      <div>
        <ModalWrap
          width="688px"
          onOk={props.onDownloadOk}
          onClose={props.onClose}
          cancelText={cancelText}
          title={getFormatMessage('download_modal_title')}
          oKText={props.showProgressBar ? '' : getFormatMessage('confirm')}
          maskClosable={false}
          loading={props.downloadLoading}
        >
          {renderContent()}
        </ModalWrap>
        {renderConfirmModal()}
      </div>
    );
  }
  return (
    <div>
      <ModalWrap
        width="688px"
        onClose={props.onClose}
        cancelText={cancelText}
        title={getFormatMessage('download_modal_title')}
        maskClosable={false}
      >
        {renderNoStepContent()}
      </ModalWrap>
      {renderConfirmModal()}
    </div>
  );
};
